import { Close as CloseIcon } from '@mui/icons-material';
import { Dialog, DialogContent, DialogTitle, Grid, IconButton, Typography } from '@mui/material';
import { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import AIImageEditor from './ai-image-editor.component';
import GenerateImageComponent from './generate-image.component';
import ImageGeneratedComponent from './image-generated.component';

const AIImageGeneration = ({ handleGeneratedAIImages = null }) => {
  const navigate = useNavigate();

  const [isGeneratingImage, setGeneratingImage] = useState(false);
  const [generatedImages, setGeneratedImages] = useState([]);
  const [editImageMediaData, setEditImageMediaData] = useState(null);
  const [isEditImagePopupOpen, setEditImagePopupOpen] = useState(false);

  const handleGeneratedPost = (images, isGeneratingImage) => {
    if (isGeneratingImage) {
      setGeneratingImage(true);
    } else {
      let genImages = [...images, ...generatedImages];
      setGeneratedImages([...genImages]);
      setGeneratingImage(false);
    }
  };

  const uploadToNewPost = (selectedFiles) => {
    const updatedData = {
      media_data: selectedFiles,
    };
    typeof handleGeneratedAIImages === 'function'
      ? handleGeneratedAIImages(updatedData.media_data)
      : navigate('/new-post', { state: { media_data: updatedData } });
  };

  const handleEditImage = (data) => {
    let images = [...data,...generatedImages];
    setGeneratedImages(images);
    handleEditImagePopup(data, true);
  };

  const handleEditedImage = (mediaUrl, updatedMediaUrl) => {
    let images = [...generatedImages];
    let data = images?.find((a) => a.media_url === mediaUrl);
    if (data) {
      data.media_url = updatedMediaUrl;
      setGeneratedImages(images);
    }
    setEditImagePopupOpen(false);
  };

  const handleEditImagePopup = (mediaData, show) => {
    setEditImageMediaData(mediaData ? mediaData[0] : null);
    setEditImagePopupOpen(show);
  };

  return (
    <>
      <Helmet>AI Image Generation</Helmet>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6} style={{ paddingBottom: '12px' }}>
          <GenerateImageComponent handleGeneratedPost={handleGeneratedPost} handleEditImage={handleEditImage} />
        </Grid>
        <Grid item xs={12} md={6} style={{ paddingBottom: '12px' }}>
          <ImageGeneratedComponent
            isGeneratingImage={isGeneratingImage}
            generatedImages={generatedImages}
            uploadToNewPost={uploadToNewPost}
            handleEdit={handleEditImagePopup}
          />
        </Grid>
      </Grid>
      <Dialog
        fullWidth
        open={isEditImagePopupOpen}
        maxWidth={false}
        PaperProps={{
          sx: {
            width: '90vw',
            maxWidth: 'none',
            height: '95vh',
          },
        }}
      >
        <DialogTitle style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Typography variant="h4">AI Image Editor</Typography>
          <IconButton
            onClick={() => {
              handleEditImagePopup(null, false);
            }}
          >
            <CloseIcon color="error" />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <AIImageEditor mediaUrl={editImageMediaData?.media_url} handleEditedImage={handleEditedImage} />
        </DialogContent>
      </Dialog>
    </>
  );
};
export default AIImageGeneration;
